import TextField from '@material-ui/core/TextField';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
import materialTheme from '../../reactMaterialTheme';
import './DescriptionField.css';

class DescriptionField extends Component {
  constructor(props) {
    super(props);
    this.shouldShowDescriptionError = this.shouldShowDescriptionError.bind(
      this
    );
  }

  shouldShowDescriptionError() {
    return this.props.description && this.props.description.length > 200;
  }

  render() {
    return (
      <MuiThemeProvider theme={materialTheme}>
        <TextField
          label="Description"
          className="description-input mb2"
          value={this.props.description}
          onChange={this.props.onChange}
          name="description"
          inputProps={{ 'data-testid': 'description-input' }}
          onFocus={event => event.target.select()}
          disabled={this.props.disabled}
          required
        />

        {this.shouldShowDescriptionError() && (
          <small
            className="error-message error mb2 mt2"
            data-testid="description-error"
          >
            Description must be 200 characters or less
          </small>
        )}
      </MuiThemeProvider>
    );
  }
}

DescriptionField.propTypes = {
  description: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};

DescriptionField.defaultProps = {
  description: '',
  disabled: false
};

export default DescriptionField;
